module.exports = __webpack_public_path__ + "img/application-title-m.6ae0450f.png";